// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
export const COPY = {
  aria: {
    banner: {
      close: 'Close banner',
    },
    modal: {
      close: 'Close modal',
      togglePlay: 'Toggle play',
      toggleTab: 'Toggle tab',
    },
  },
} as const
